import React from 'react';
import useStore from '../store/useStore';

const getAgentColor = (agent) => {
  const colors = {
    dev: 'text-blue-400 bg-blue-400/10 border-blue-400/20',
    marketing: 'text-green-400 bg-green-400/10 border-green-400/20',
    design: 'text-purple-400 bg-purple-400/10 border-purple-400/20',
    research: 'text-orange-400 bg-orange-400/10 border-orange-400/20',
    communication: 'text-teal-400 bg-teal-400/10 border-teal-400/20',
    project: 'text-red-400 bg-red-400/10 border-red-400/20',
    security: 'text-gray-400 bg-gray-400/10 border-gray-400/20',
  };
  return colors[agent?.toLowerCase()] || 'text-gray-400 bg-gray-400/10 border-gray-400/20';
};

const ResponseDisplay = () => {
  const currentTask = useStore((state) => state.currentTask);
  const response = useStore((state) => state.response);
  const loading = useStore((state) => state.loading);
  const activeAgent = useStore((state) => state.activeAgent);

  if (!currentTask && !response && !loading) return null;

  return (
    <div className="flex flex-col gap-4 mt-6 p-4 rounded-xl border border-gray-700 bg-gray-800/50">
      {currentTask && (
        <div className="flex flex-col">
          <span className="text-xs text-gray-400 uppercase tracking-wider mb-1">Task</span>
          <p className="text-white text-sm bg-gray-700/50 p-3 rounded-lg">{currentTask}</p>
        </div>
      )}

      {loading && (
        <div className="flex items-center gap-3 p-3">
          <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-sm text-gray-400">Agent Zero is orchestrating...</span>
        </div>
      )}

      {response && (
        <div className="flex flex-col">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-gray-400 uppercase tracking-wider">Response</span>
            {activeAgent && (
              <span className={`text-xs px-2 py-1 rounded-md border ${getAgentColor(activeAgent)}`}>
                Handled by: {activeAgent.charAt(0).toUpperCase() + activeAgent.slice(1)} Agent
              </span>
            )}
          </div>
          <div className="text-gray-200 text-sm bg-gray-900/50 p-4 rounded-lg whitespace-pre-wrap font-mono">
            {response}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResponseDisplay;
